// extracted by mini-css-extract-plugin
export default {"relatedCards":"RelatedResources-module__relatedCards--s_M0q"};